import React from 'react'
import AlumniDash from '../../Components/AlumniComponent/AlumniDash/AlumniDash'
import JobSharingForm from '../../Components/AlumniComponent/JobSharing/JobSharing'

function JobSharingPage() {
  return (
    <AlumniDash>
        <JobSharingForm/>
    </AlumniDash>
  )
}

export default JobSharingPage